import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule, FitTextModule } from '@shared/components/games';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BlindReadingControllerComponent } from './blind-reading-controller/blind-reading-controller.component';
import { BlindReadingSettingsComponent } from './blind-reading-settings/blind-reading-settings.component';
import { TranslateModule } from '@ngx-translate/core';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';

@NgModule({
  declarations: [BlindReadingControllerComponent, BlindReadingSettingsComponent],
  exports: [BlindReadingControllerComponent, BlindReadingSettingsComponent],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ButtonModule,
    FitTextModule,
    GamesSharedModule,
  ],
})
export class BlindReadingModule {}
